function initRwAccordion() {
  const accordions = document.querySelectorAll('.rw-accordion');

  accordions.forEach((accordion) => {
    if (accordion.dataset.rwAccordionInit === 'true') return;
    accordion.dataset.rwAccordionInit = 'true';

    const items = accordion.querySelectorAll('details');
    const summaries = accordion.querySelectorAll('summary');

    items.forEach((item) => {
      item.removeAttribute('open');
    });

    summaries.forEach((summary) => {
      summary.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          const current = summary.parentElement;
          const shouldOpen = !current.hasAttribute('open');

          items.forEach((item) => {
            item.removeAttribute('open');
          });

          if (shouldOpen) {
            current.setAttribute('open', '');

            setTimeout(function () {
             summary.scrollIntoView({
             behavior: 'smooth',
             block: 'start'
           });
          }, 80);
          }
        },
        true
      );
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRwAccordion);
} else {
  initRwAccordion();
}

document.addEventListener('shopify:section:load', initRwAccordion);